import React, { useEffect, useState } from "react";
import productAPI from "../../api/productApi";
import Product from "../products/Card";
import { Link } from "react-router-dom";
import { Search, X, ArrowRight } from "lucide-react";

function SearchCanvas({ isOpen, searchText, setSearchText, closeSearch }) {
  const [loading, setLoading] = useState(false);
  const [products, setProducts] = useState([]);
  const [page, setPage] = useState(1);

  // const [searchText, setSearchText] = useState("");

  useEffect(() => {
    if (!searchText) {
      setProducts([]);
      return;
    }

    const delay = setTimeout(() => {
      fetchProducts(1, searchText);
    }, 400);

    return () => clearTimeout(delay);
  }, [searchText]);

  const fetchProducts = async (pageNum = 1, searchText) => {
    setLoading(true);

    try {
      if (searchText) {
        const res = await productAPI.listing({
          page: pageNum,
          limit: 6,
          keyword: searchText,
        });

        if (res.code === 200) {
          const { products, base_url } = res.data;

          const items = products;

          setProducts((prev) => (pageNum === 1 ? items : [...prev, ...items]));
        }
      }
    } catch (err) {
      console.error("Error loading products:", err);
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="full-search-overlay" onClick={closeSearch}>
      <div className="full-search-wrapper" onClick={(e) => e.stopPropagation()}>
        <div className="full-search-header">
          <div className="full-search-input">
            <Search size={22} />

            <input
              autoFocus
              placeholder="Search Products..."
              value={searchText}
              onChange={(e) => setSearchText(e.target.value)}
            />
          </div>

          <button onClick={closeSearch}>
            <X size={28} className="text-dark" />
          </button>
        </div>

        <div className="full-search-body">
          {loading && <div className="text-center py-5">Loading...</div>}

          {!loading &&
            products.map((product) => {
              const image = product.thumbnail || product.images?.[0];

              const price = product.variants?.[0]?.price || product.price;

              return (
                <Link
                  key={product._id}
                  to={`/shop/${product.slug}`}
                  className="search-item"
                  onClick={closeSearch}
                >
                  <img src={image} className="search-img" alt={product.title} />

                  <div className="search-content">
                    <h5 className="search-title">{product.title}</h5>

                    <div className="search-price">₹{price}</div>
                  </div>

                  <ArrowRight size={20} className="search-arrow" />
                </Link>
              );
            })}
        </div>
      </div>
    </div>
  );
}

export default SearchCanvas;
